import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useJWTAuth } from "../context/JWTAuthContext";

const TutorRoute = () => {
  const { isAuthenticated, hasRole, getUserRole, loading } = useJWTAuth();

  // Показываем индикатор загрузки, пока проверяем аутентификацию и роль
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--color-primary)]"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Тьюторы и администраторы имеют доступ к тьюторским страницам
  const userRole = getUserRole();
  const hasAccess =
    hasRole("tutor") ||
    ["admin", "superadmin", "megaadmin", "assistant"].includes(userRole);

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default TutorRoute;
